import React from 'react';
import { SummaryField } from '../SummaryField';
import styles from './DisplaySection.module.scss';
import { PDFHighlightPreview } from '../Sections/PDFHighlightPreview';
import { IDisplaySection } from './DisplaySection.interface';
import { ContentToggleSection } from '../ContentToggleSection';

export const DisplaySection = ({
  title,
  fieldsArray,
  file,
  pdfCustomStyle,
  titleStyle,
  fieldStyle
}: IDisplaySection): React.JSX.Element => {
  return (
    <ContentToggleSection title={title} titleStyle={titleStyle}>
      <div className={styles['data-display']}>
        <div className={styles.fields}>
          {fieldsArray.map((field) => (
            <SummaryField
              key={`field-${field.query}`}
              id={`field-${field.query}`}
              title={field.query}
              value={field.value}
              fieldStyle={fieldStyle}
            />
          ))}
        </div>

        {file && (
          <div className={styles.wrapper}>
            <div className={styles.preview} style={pdfCustomStyle}>
              <PDFHighlightPreview
                highlightCoords={undefined}
                selectedHighlight={undefined}
                showHighlights={false}
                displayFile={file}
              />
            </div>
          </div>
        )}
      </div>
    </ContentToggleSection>
  );
};
